import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { confirmEmail } from "sources/account";

export default function ConfirmEmail() {
    const { query } = useRouter();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        confirmEmail(query.userId, query.token).then(() => {
            setLoading(false);
        });
    }, [query.userId, query.token]);
    return (
        <div className="no-overflow h-100">
            <div className="identity-container">
                {loading && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <div className="identity-container__shadow" />
                <div className="identity-container__background" />
                <div className="identity-panel identity-panel--big">
                    <div className="identity-container__title" aria-label="Подтверждение почты" />
                    <h4>Спасибо за подтверждение почты. Пройдите по кнопке ниже, чтобы войти в нашу систему</h4>
                    <div className="identity-form__button-group col-12">
                        <Link className="identity-form__button identity-form__button--yellow" to={paths.login}>
                            Войти
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
